// Utils
import cn from '../../../../utils/cn';
// Styles
import styles from './DateCell.module.css';
import commonStyles from '../TableCellCommon.module.css';

/**
 * DateCell component for displaying dates/datetimes in table cells (read-only)
 * @param {object} props - Component props
 * @param {string} [props.value=''] - Raw date/datetime string from the API (displayed as-is)
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.placeholder='--'] - Placeholder for empty values
 * @param {Align} [props.align='left'] - Text alignment
 * @param {VerticalAlign} [props.verticalAlign='middle'] - Vertical alignment
 * @param {boolean} [props.bold=false] - Text in bold
 * @param {boolean} [props.italic=false] - Text in italic
 * @param {boolean} [props.strikeThrough=false] - Text with strike-through
 * @param {boolean} [props.underline=false] - Text underlined
 * @returns {JSX.Element} DateCell component
 */
export default function DateCell({
  value = '',
  className = '',
  placeholder = '--',
  align = 'left',
  verticalAlign = 'middle',
  bold = false,
  italic = false,
  strikeThrough = false,
  underline = false,
}) {
  const isEmpty = !value || value === '';
  const displayValue = isEmpty ? placeholder : value;

  return (
    <div
      className={cn([
        styles['date-cell-wrapper'],
        className,
        bold && commonStyles['cell-bold'],
        italic && commonStyles['cell-italic'],
        strikeThrough && commonStyles['cell-strike-through'],
        underline && commonStyles['cell-underline'],
        align && commonStyles[`cell-align-${align}`],
        verticalAlign && commonStyles[`cell-vertical-align-${verticalAlign}`],
      ])}
    >
      <div
        className={cn([
          styles['date-cell-input'],
          align === 'right' && commonStyles['cell-crop-start'],
        ])}
      >
        {align === 'right' ? <bdi dir="ltr">{displayValue}</bdi> : displayValue}
      </div>
    </div>
  );
}
